import { useCallback, useEffect, useState } from 'react';

interface ResizeKeyboardEvent extends KeyboardEvent {
  keyboardHeight?: number;
}

/**
 * Listens for ionic window events
 *  - provides whether or not keyboard is open
 *  - proviees keyboard height
 */
export const useKeyboardState = () => {
  const [keyboardState, setKeyboardState] = useState({
    isKeyboardOpen: false,
    keyboardHeight: 0,
  });

  const keyboardShowHandler = useCallback((event: Event) => {
    const { keyboardHeight } = (event as unknown) as ResizeKeyboardEvent;
    setKeyboardState({ isKeyboardOpen: true, keyboardHeight: keyboardHeight ?? 0 });
  }, []);

  const keyboardHideHandler = useCallback(() => {
    setKeyboardState({ isKeyboardOpen: false, keyboardHeight: 0 });
  }, []);

  useEffect(() => {
    window.addEventListener('keyboardWillShow', keyboardShowHandler);
    window.addEventListener('keyboardWillHide', keyboardHideHandler);
    return () => {
      window.removeEventListener('keyboardWillShow', keyboardShowHandler);
      window.removeEventListener('keyboardWillHide', keyboardHideHandler);
    };
  }, [keyboardHideHandler, keyboardShowHandler]);

  return keyboardState;
};
